<template>
  <div class="block-mobile-apps">
    <div class="block-mobile-apps__top">
      <img
        class="block-mobile-apps__img"
        src="https://storage.yandexcloud.net/boxberrysite-public/icons/icon-mobile-app.svg"
        width="60"
        height="60"
        alt="Мобильное приложение"
      >
      <p class="block-mobile-apps__text">
        Просто и&nbsp;удобно
        отслеживать посылки
        <strong>
          в&nbsp;мобильном приложении Boxberry
        </strong>
      </p>
    </div>

    <MobileStoresQRBlock
      class="block-mobile-apps__qr-block"
      :qr-code-image-src="qrCodeImageSrc"
    />
    <MobileStoresShopLinks
      class="block-mobile-apps__shop-links"
      :google-play-link="googlePlayLink"
      :app-store-link="appStoreLink"
      :huawei-link="huaweiLink"
    />
  </div>
</template>

<script>
import MobileStoresQRBlock from '../MobileStores/MobileStoresQRBlock.vue';
import MobileStoresShopLinks from '../MobileStores/MobileStoresShopLinks.vue';

export default {
  name: 'BlockMobileApps',
  components: {
    MobileStoresQRBlock, MobileStoresShopLinks,
  },
  props: {
    qrCodeImageSrc: {
      type: String,
      required: true,
    },
    googlePlayLink: {
      type: String,
      required: true,
    },
    appStoreLink: {
      type: String,
      required: true,
    },
    huaweiLink: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  @import "./BlockMobileApps";
</style>
